import type { IGetActionsData } from "@api";
import { useGlobalContext } from "@root/context";
import { isActionLate } from "@root/utils/actions";
import { useI18nContext } from "@root/utils/organisation";
import { useMemo } from "react";
import { classes } from "./styles";

const getStatusClass = (action: IGetActionsData, timeZone: string) => {
  switch (action.status) {
    case "todo":
      if (action.deadlineDate || action.executionPeriod) {
        if (isActionLate(action, timeZone)) {
          return classes.late;
        }
        return classes.todo;
      }
      return "";
    case "done":
      return classes.done;
    case "missed":
      return classes.missed;
    default:
      return "";
  }
};

export const useActionCard = (action: IGetActionsData) => {
  const { settingsV2, challenges } = useGlobalContext();
  const { timeZone } = useI18nContext();

  const formattedAction = useMemo(() => {
    const actionTypeLabel =
      settingsV2.statusTodoType?.values.find((setting) => setting.value === action.type)?.label ?? "Sans titre";

    const approachLabel = action.approach
      ? challenges.flatMap((c) => c.approaches ?? []).find((a) => a._id === action.approach)?.label
      : undefined;

    return {
      actionTypeLabel,
      candidate: action.candidate,
      statusClass: getStatusClass(action, timeZone),
      title: action.title || approachLabel || actionTypeLabel,
    };
  }, [action, settingsV2.statusTodoType, challenges, timeZone]);

  return formattedAction;
};
